import { useContext } from 'react';
import { UsersContext } from 'contexts/usersContext/UsersContext';

export const useUsersContext = () => {
	return useContext(UsersContext);
};
